import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

import '@splidejs/react-splide/css'
import './scssStyles/slider2.scss'

import Des1 from '../images/slider1/one.webp'
import Des2 from '../images/slider1/two.webp'
import Des3 from '../images/slider1/three.webp'
import Des4 from '../images/slider1/four.webp'
// import Des5 from '../images/slider1/five.webp'
import Des6 from '../images/slider1/six.webp'
import Des7 from '../images/slider1/seven.webp'
import Des8 from '../images/slider1/eight.webp'
import Des9 from '../images/slider1/nine.webp'
import Des10 from '../images/slider1/ten.webp'
import Des11 from '../images/slider1/eleven.webp'
import Des12 from '../images/slider1/twelve.webp'
import Des13 from '../images/slider1/thirteen.webp'
import Des14 from '../images/slider1/fourteen.webp'
import Des15 from '../images/slider1/fifteen.webp'
import Des16 from '../images/slider1/sixteen.webp'
import Des17 from '../images/slider1/seventeen.webp'
import Des18 from '../images/slider1/eighteen.webp'
import Des19 from '../images/slider1/nineteen.webp'

export default function Slider() {

  const products = [
    { image: Des1, alt: 'Crepes' },
    { image: Des3, alt: 'Strawberry milkshake' },
    { image: Des15, alt: 'Pancake Stack' },
    { image: Des6, alt: 'Bueno Shake' },
    { image: Des19, alt: 'Crepes' },
    { image: Des9, alt: 'Caramel milkshake' },
    { image: Des4, alt: 'Oreo Shake' },
    { image: Des13, alt: 'Pancake Stack' },
    { image: Des10, alt: 'Milkshake' },
    { image: Des18, alt: 'Fudge puppies' },
    { image: Des8, alt: 'Milkshake' },
    { image: Des16, alt: 'Pancake Stack' },
    { image: Des12, alt: 'Milkshake' },
    { image: Des2, alt: 'Crepes' },
    { image: Des17, alt: 'Pancake' },
    { image: Des11, alt: 'Milkshake' },
    { image: Des14, alt: 'Churros' },
    { image: Des7, alt: 'Bueno milkshake' }
  ]

  return (
    <div className="slider">

      <Splide
        extensions={{ AutoScroll }}

        options={{
          type: 'loop',

          autoWidth: true,

          focus: 'center',

          gap: '0px',

          arrows: false,

          pagination: false,

          drag: false,

          rewind: false,

          clones: 10,

          autoScroll: {
            speed: 1,
            pauseOnHover: false,
            pauseOnFocus: false
          }
        }}
      >

        {products.map((product, index) => (
          <SplideSlide key={index}>

            <div className="slide">
              <img
                src={product.image}
                alt={product.alt}
              />
            </div>

          </SplideSlide>
        ))}

      </Splide>

    </div>
  )
}